import { RootState } from "../store";
import { Holder } from "../../interfaces";

export const getUser = (state: RootState) => state.user.currentUser;
export const getCurrentRole = (state: RootState) => state.user.currentRole;
export const getHolderCity = (state: RootState) =>
  (state.user.currentUser as Holder).cityId;
export const getAvailableRoles = (state: RootState) =>
  state.user.currentUser?.roles;
